// extracted by mini-css-extract-plugin
export default {"tMargin":"MapMarker_tMargin__RPHJL","boundaryHeader":"MapMarker_boundaryHeader__Iezag","map":"MapMarker_map__f6yjL"};